// extracted by mini-css-extract-plugin
export var layoutContainer = "_c-0";
export var layoutContainerNoRounding = "_c-6";
export var layoutContainerOpen = "_c-5";
export var layoutContainerResizing = "_c-1";
export var mainContent = "_c-2";
export var resizeDivider = "_c-3";
export var slidePanel = "_c-4";